import { type TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux";
import type { AppDispatch, RootState } from "#/store/makeStore";
export const useAppDispatch = () => {
  return useDispatch();
};
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = () => {
  return useStore();
};